import React from "react";

/** How many action buttons a row shows (same conditions as the buttons below). */
export const actionCount = (row, { onChangeHotel, onChangeStay, stayEnabled = false } = {}) =>
  [Boolean(row.employeeNumber), Boolean(onChangeHotel && row.allowAllocateHotel), Boolean(stayEnabled && onChangeStay && row.allowChangeAddress)].filter(Boolean)
    .length;

/** Most buttons of any row: the actions column is that wide (one button when no row can change its hotel). */
export const mostActions = (rows, actions) => Math.max(1, ...(rows ?? []).map((r) => actionCount(r, actions)));

/** Width of the fixed actions column for that many buttons: 30px buttons, 4px gaps, 6px cell padding, 4px spare. */
export const actionsWidth = (buttons) => 16 + Math.max(1, buttons) * 30 + (Math.max(1, buttons) - 1) * 4;

/**
 * A row's actions (grid cell and card): the Crew app view, Change hotel (when the API allows it) and Change stay location
 * (only when enabled). onMobile / onChangeHotel / onChangeStay(row).
 */
export default function ActivityActions({ row, onChangeHotel, onChangeStay, onMobile, stayEnabled = false, large = false }) {
  const cls = `dsp-act${large ? " dsp-act--lg" : ""}`;
  const who = row.fullName || row.employeeNumber;
  return (
    <span className="dsp-acts">
      {row.employeeNumber && (
        <button type="button" className={cls} title="Crew app view" aria-label={`Crew app view for ${who}`} onClick={() => onMobile(row)}>
          <i className="fas fa-mobile-alt" aria-hidden="true" />
          {large && <span>Crew app view</span>}
        </button>
      )}
      {onChangeHotel && row.allowAllocateHotel && (
        <button type="button" className={`${cls} is-live`} title="Change hotel" aria-label={`Change hotel for ${who}`} onClick={() => onChangeHotel(row)}>
          <i className="fas fa-hotel" aria-hidden="true" />
          {large && <span>Change hotel</span>}
        </button>
      )}
      {stayEnabled && onChangeStay && row.allowChangeAddress && (
        <button type="button" className={cls} title="Change stay location" aria-label={`Change stay location for ${who}`} onClick={() => onChangeStay(row)}>
          <i className="fas fa-home" aria-hidden="true" />
          {large && <span>Stay location</span>}
        </button>
      )}
    </span>
  );
}
